import styled from 'styled-components/macro';

const SectionWrapper = styled.div`
  margin-bottom: 3rem;
`;

export default SectionWrapper;
